import { parsePlayer } from '../models/types';
import { authService } from '../services/authService';
import { Logger } from '../services/logger';
import { RealtimeClient } from '../services/realtimeClient';
import { usePlayer } from './player';

const log = new Logger('RealtimeManager');

let client: RealtimeClient | null = null;
let currentUid: string | null = null;

function stop() {
  client?.close();
  client = null;
}

/** Keeps one WebSocket open to `/player/<uid>` and applies `player.updated` events. */
export function startRealtime(uid: string) {
  stop();
  currentUid = uid;
  client = new RealtimeClient({
    getToken: () => authService.idToken(),
    onReconnected: () => void usePlayer.getState().refresh(),
    onEvent: (payload) => {
      if (payload.type === 'player.updated' && payload.player && typeof payload.player === 'object') {
        try {
          usePlayer.getState().applyRealtime(parsePlayer(payload.player as Record<string, unknown>));
        } catch (e) {
          log.error('bad player.updated payload', { error: e });
        }
      }
    },
  });
  client.subscribe(`/player/${uid}`);
}

export function stopRealtime() {
  currentUid = null;
  stop();
}

/** Called from the page lifecycle: pause in background, resume in foreground. */
export function setForeground(foreground: boolean) {
  if (!foreground) {
    stop();
  } else if (currentUid && !client) {
    startRealtime(currentUid);
    void usePlayer.getState().refresh();
  }
}
